import { Children, Component } from 'react';

import { Provider } from 'react-redux';

import configureStore, {
    storeHandler,
    resetStoreValue,
    RootState
} from './configureStore';

class IwProvider extends Component<{
    initialState?: Partial<RootState>;
}> {
    // eslint-disable-next-line react/no-unsafe
    UNSAFE_componentWillMount() {
        const { initialState } = this.props;
        let storeClass;

        if (typeof initialState === 'undefined') {
            storeClass = configureStore();
        } else {
            storeClass = configureStore(initialState);
        }

        return storeClass;
    }

    componentWillUnmount() {
        resetStoreValue({});
    }

    render() {
        const { children } = this.props;

        return (
            <Provider store={storeHandler.store}>
                {Children.only(children)}
            </Provider>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default IwProvider;
